/* Native pagination, with an independent return position for each history entry. */
(()=>{
 if(!document.querySelector('#product-grid'))return;
 const stateKey='arelanaCatalogReturn';
 const currentUrl=()=>location.pathname+location.search;
 let clickedCard=null,restoring=false,cancelRestore=()=>{};
 const cardPath=card=>{
  const link=card?.querySelector('a[href*="/products/"]');
  try{return link?new URL(link.href,location.href).pathname:null;}catch{return null;}
 };
 const filterDetails=()=>Array.from(document.querySelectorAll('#main-collection-filters details'));
 const save=()=>{
  if(restoring)return;
  const cards=Array.from(document.querySelectorAll('#product-grid>li'));
  const card=clickedCard?.isConnected?clickedCard:cards.find(node=>{
   const r=node.getBoundingClientRect();return r.bottom>100&&r.top<innerHeight;
  });
  const snapshot={url:currentUrl(),x:scrollX,y:scrollY,card:cardPath(card),
   offset:card?.getBoundingClientRect().top??0,width:innerWidth,
   filters:filterDetails().map(node=>({id:node.id,open:node.open})),
   filterScroll:document.querySelector('#main-collection-filters')?.scrollTop||0};
  try{history.replaceState({...history.state,[stateKey]:snapshot},'');}catch{}
 };
 document.addEventListener('click',event=>{
  const link=event.target.closest?.('a[href]');
  if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.target==='_blank')return;
  const card=link.closest('#product-grid>li');
  if(!card)return;
  let target;try{target=new URL(link.href);}catch{return;}
  if(target.origin!==location.origin||!target.pathname.includes('/products/'))return;
  clickedCard=card;save();
 },true);
 addEventListener('pagehide',save);
 const restore=()=>{
  const snapshot=history.state?.[stateKey];
  if(!snapshot||snapshot.url!==currentUrl()||!Number.isFinite(snapshot.y))return;
  cancelRestore();restoring=true;clickedCard=null;
  const nodes=filterDetails();
  snapshot.filters?.forEach((saved,index)=>{
   const node=saved.id?nodes.find(item=>item.id===saved.id):nodes[index];
   if(node)node.open=!!saved.open;
  });
  const side=document.querySelector('#main-collection-filters');
  if(side)side.scrollTop=snapshot.filterScroll||0;
  let stopped=false,observer,timers=[];
  const stop=()=>{
   if(stopped)return;stopped=true;restoring=false;observer?.disconnect();timers.forEach(clearTimeout);
   for(const name of ['wheel','touchstart','pointerdown','keydown'])removeEventListener(name,stop,true);
  };
  cancelRestore=stop;
  const position=()=>{
   if(stopped||currentUrl()!==snapshot.url)return;
   const card=Array.from(document.querySelectorAll('#product-grid>li')).find(node=>cardPath(node)===snapshot.card);
   const target=card?scrollY+card.getBoundingClientRect().top-snapshot.offset:snapshot.y;
   scrollTo({left:snapshot.x||0,top:Math.max(0,target),behavior:'instant'});
  };
  for(const name of ['wheel','touchstart','pointerdown','keydown'])addEventListener(name,stop,{capture:true,passive:true});
  if('ResizeObserver' in window){observer=new ResizeObserver(position);observer.observe(document.querySelector('#MainContent')||document.body);}
  position();
  for(const delay of [0,80,250,600,1200])timers.push(setTimeout(position,delay));
  document.fonts?.ready.then(position);
  timers.push(setTimeout(stop,1500));
 };
 // Leave native restoration enabled as a fallback if this script cannot run.
 if('scrollRestoration' in history)history.scrollRestoration='auto';
 addEventListener('pageshow',restore);
 if(document.readyState==='complete')restore();
})();
